function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (
    !openDetailsElement ||
    openDetailsElement.getAttribute("disabled") !== null
  )
    return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

/**
 * Writes "N is the maximum available quantity currently" into a cart line's inline message.
 *
 * Inline rather than a dialog: nothing to dismiss, nothing blocked, and it sits next to the control
 * it is about. It uses the `.cart-item__error` element cart-item.liquid already renders — the same
 * one cart.js writes Shopify's own capped-quantity message into — so nothing extra has to exist.
 *
 * The copy comes from that element's data attribute, keeping the translated string in Liquid; only
 * the number is filled in here. The CSS reveals it while the text is non-empty and hides it again
 * once a successful update re-renders the line, so nothing has to remember to clear it.
 *
 * Shared by two callers: the + stepper (QuantityInput, below) and a typed value that cart.js had to
 * clamp. No-ops wherever the element is absent, so the product page stepper is unaffected.
 *
 * @param {Element} scope   an element containing the line's .cart-item__error
 * @param {number}  max     the available quantity
 */
function setQuantityLimitNotice(scope, max) {
  const notice = scope && scope.querySelector(".cart-item__error");
  const text = notice && notice.querySelector(".cart-item__error-text");
  if (!text) return;

  text.textContent = (notice.dataset.quantityLimitTemplate || "").replace(
    "__QTY__",
    max
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("change", this.updatePrice.bind(this));
    this.input.addEventListener("keyup", this.updatePrice.bind(this));
    this.input.addEventListener("focusout", this.setMin.bind(this));
    this.input.addEventListener("keydown", this.onKeyDown.bind(this));
  }

  /**
   * Stops Enter submitting the form the input happens to sit in.
   *
   * On the cart page that input is inside `<form id="cart" action="/cart" method="post">`, and Enter
   * triggers implicit submission — which the browser attributes to the form's first submit button.
   * The only candidate is the checkout button (the other is inside <noscript>), so its
   * `name="checkout"` went along for the ride:
   *
   *   POST /cart  updates[]=100&checkout=  ->  302 /checkout/...
   *
   * Shopify then found the posted quantities disagreed with the cart and bounced back with "Cart
   * contents have changed, you must click 'Update cart' before proceeding" — its own copy, which is
   * why it was nowhere in this theme.
   *
   * It also explains the quantity appearing to revert and the price not updating: the full-page
   * submit was navigating away before the AJAX update could land.
   *
   * Dispatching `change` here keeps Enter doing what the shopper expects — commit the value — which
   * routes through the same clamp and update path as blurring the field.
   */
  onKeyDown(event) {
    if (event.code !== "Enter" && event.key !== "Enter") return;

    event.preventDefault();
    this.input.dispatchEvent(this.changeEvent);
  }

  onButtonClick(event = null) {
    if (event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      } else if (event.target.name === "plus") {
        // stepUp() refused. It leaves the value untouched and fires nothing, so the click would
        // otherwise be silently ignored — which reads as a broken button. The only reason it
        // refuses here is the `max` the cart line renders from the variant's available stock.
        this.showQuantityLimitNotice();
      }
    }

    const inputs = document.querySelectorAll(
      `quantity-input input[data-product="${this.input.getAttribute(
        "data-product"
      )}"],
      quantity-input input[form="${this.input.getAttribute("form")}"]`
    );
    inputs.forEach((input) => {
      if (
        input !== this.input &&
        input.getAttribute("id") == this.input.getAttribute("id") &&
        !input.classList.contains("bundle-option-quantity")
      ) {
        input.value = this.input.value;
        if (input.closest("product-form").querySelector("total-price")) {
          input
            .closest("product-form")
            .querySelector("total-price").dataset.quantity = this.input.value;
        }
      }
    });
    this.updatePrice();
  }

  /**
   * Raised when + is pressed at the ceiling. Delegates to the shared writer below, which cart.js
   * also uses for a typed value that had to be clamped.
   */
  showQuantityLimitNotice() {
    const max = parseInt(this.input.getAttribute("max"), 10);
    // No declared ceiling means stepUp() refused for some other reason (disabled input, bad
    // value); claiming they had reached a maximum would be wrong.
    if (!Number.isFinite(max)) return;

    setQuantityLimitNotice(this.closest(".cart-item__quantity"), max);
  }

  updatePrice() {
    const productForm = this.closest("product-form");
    const priceContainer = productForm?.querySelector("total-price");
    if (priceContainer) priceContainer.dataset.quantity = this.input.value;

    // Check for product availability (in stock)
    let inStock = true;
    // Try to get availability from a data attribute on the input or form
    if (this.input.hasAttribute("data-available")) {
      inStock = this.input.getAttribute("data-available") === "true";
    } else if (productForm && productForm.hasAttribute("data-available")) {
      inStock = productForm.getAttribute("data-available") === "true";
    }

    // Disable add to cart button if quantity is 0 or not in stock, enable if >= 1 and in stock
    // if (productForm) {
    //   const addButton = productForm.querySelector('button[name="add"]');
    //   if (addButton) {
    //     if (parseInt(this.input.value, 10) < 1 || !inStock) {
    //       addButton.setAttribute("disabled", "disabled");
    //     } else {
    //       addButton.removeAttribute("disabled");
    //     }
    //   }
    // }
  }

  setMin() {
    var isCart = this.closest(".cart-item__quantity-wrapper");
    if (isCart) {
      if (this.input.value >= 1) {
        this.input.value = this.input.value;
      } else {
        this.input.value = 0;
      }
    } else if (this.input.value < 1) {
      this.input.value = 1;
    }
    this.onButtonClick();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    console.log(this);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (
      !openDetailsElement ||
      openDetailsElement.getAttribute("disabled") !== null
    )
      return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section.section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    let gaiaHeader = this;

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1232) {
        document.body.classList.remove("overflow-hidden");
      }
    });

    window.addEventListener("scroll", () => {
      let headerRect = gaiaHeader.getBoundingClientRect();
      let headerPos = 0;
      if (window.scrollY > this.previousScroll) {
        // scrolling down
        this.classList.remove("border-bottom");
        headerPos = 0 - headerRect.height;
      } else {
        // scrolling up
      }
      this.style.top = `${headerPos}px`;
      this.previousScroll = window.scrollY;

      if (window.scrollY > 0) {
        this.classList.add("header-border");
      } else {
        this.classList.remove("header-border");
      }
    });

    this.addEventListener("click", () => {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.getBoundingClientRect().bottom)}px`
      );
    });

    // Close on esc key
    window.addEventListener("keyup", (e) => {
      if (e.code === "Escape" || e.key === "Escape") {
        // Remove overflow-hidden from body
        document.body.classList.remove("overflow-hidden");
        document
          .querySelectorAll(".shopify-section.section-header details[open]")
          .forEach((openDetails) => {
            openDetails.removeAttribute("open");
            const summary = openDetails.querySelector("summary");
            if (summary) summary.setAttribute("aria-expanded", "false");
          });

        const header = document.querySelector(
          ".shopify-section.section-header"
        );
        if (header) header.classList.remove("menu-open");
      }
    });

    let mobileMenuCurrentLevel = "0";
    let mobileMenuCurrentParent = null;

    // Mobile menu tiers
    const setupMobileMenuDrilldown = () => {
      const menuRoot = document.getElementById("mobile-menu-drilldown");
      if (!menuRoot) return;
      if (window.innerWidth >= 1232) return;

      // Try to restore previous state
      let selector = `.mobile-menu-view[data-level="${mobileMenuCurrentLevel}"]`;
      if (mobileMenuCurrentParent)
        selector += `[data-parent="${mobileMenuCurrentParent}"]`;
      let viewToShow =
        menuRoot.querySelector(selector) ||
        menuRoot.querySelector('.mobile-menu-view[data-level="0"]');

      // Hide all views
      menuRoot.querySelectorAll(".mobile-menu-view").forEach((view) => {
        view.style.display = "none";
      });

      // Show the correct view
      if (viewToShow) viewToShow.style.display = "";

      let currentView = viewToShow;

      menuRoot.addEventListener("click", function (e) {
        const nextBtn = e.target.closest("button.mobile-menu-next");
        const backBtn = e.target.closest("button.mobile-menu-back");

        if (nextBtn) {
          const index = nextBtn.getAttribute("data-index");
          currentView.style.display = "none";
          const nextView = menuRoot.querySelector(
            `.mobile-menu-view[data-parent="${index}"]`
          );
          if (nextView) {
            nextView.style.display = "";
            currentView = nextView;
            // Store state
            mobileMenuCurrentLevel = nextView.getAttribute("data-level");
            mobileMenuCurrentParent = nextView.getAttribute("data-parent");
          }
        }
        if (backBtn) {
          const parentLevel =
            parseInt(currentView.getAttribute("data-level")) - 1;
          let parentView;
          if (parentLevel === 0) {
            parentView = menuRoot.querySelector(
              '.mobile-menu-view[data-level="0"]'
            );
          } else {
            const parentIndex = currentView
              .getAttribute("data-parent")
              .split("-")[0];
            parentView = menuRoot.querySelector(
              `.mobile-menu-view[data-level="${parentLevel}"][data-parent="${parentIndex}"]`
            );
          }
          if (parentView) {
            currentView.style.display = "none";
            parentView.style.display = "";
            currentView = parentView;
            // Store state
            mobileMenuCurrentLevel = parentView.getAttribute("data-level");
            mobileMenuCurrentParent = parentView.getAttribute("data-parent");
          }
        }
      });
    };

    // Run on load and on resize (for SPA or viewport changes)
    window.addEventListener("DOMContentLoaded", setupMobileMenuDrilldown);
    window.addEventListener("resize", setupMobileMenuDrilldown);
    setupMobileMenuDrilldown();
    // --- End mobile menu drilldown logic ---
  }
}

customElements.define("gaia-header", GaiaHeader);

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    this.details.classList.add("closed");

    if (this.content.getAttribute("tabindex") === null)
      this.content.setAttribute("tabindex", "0");

    this.summary.addEventListener("click", (e) => {
      this.click(e);
    });

    this.clickOffListener = this.clickOff.bind(this);

    this.details.addEventListener("toggle", () => {
      if (this.details.open) {
        this.details.classList.remove("closed", "closing");
        this.details.classList.add("open");
      } else {
        this.details.classList.remove("open", "opening");
        this.details.classList.add("closed");
      }
    });
  }

  clickOff(e) {
    if (this.details.open && !this.contains(e.target)) {
      this.close();
    }
  }

  click(e) {
    e.preventDefault();
    if (
      this.details.open ||
      this.details.classList.contains("opening") ||
      this.details.classList.contains("open")
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      let ariaLabel = detailsElement.getAttribute("aria-label") || "";
      if (detailsElement.hasAttribute("open")) {
        ariaLabel = ariaLabel.replace("Open", "Close");
      } else {
        ariaLabel = ariaLabel.replace("Close", "Open");
      }
      detailsElement.setAttribute("aria-label", ariaLabel);
    }
  }

  open() {
    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details"))
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    setTimeout(() => {
      this.details.classList.remove("opening");
      this.details.classList.add("open");
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    }, 300);

    this.updateAriaLabel();
    resizeAllMasonryItems(".masonry-grid");
    document.addEventListener("click", this.clickOffListener);
  }

  close() {
    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details"))
      document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.classList.remove("closing");
      this.details.classList.add("closed");
    }, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);

class GaiaSelect extends GaiaDropdown {
  constructor() {
    super();

    this.selectedOption = this.querySelector(".selected-option");
    this.fieldset = this.querySelector("fieldset");
    this.options = this.querySelector(".options");
    this.summary = this.querySelector("summary");
    //Looking for  <gaia-select data-subscription-widget="true"></gaia-select>
    this.isSubscriptionWidget = this.hasAttribute("data-subscription-widget");

    this.options.removeAttribute("tabindex");

    this.fieldset.addEventListener("change", (event) => {
      // Only look for checked input inside the options container of this GaiaSelect instance
      const checked = this.querySelector(".options input:checked");
      if (checked) {
        if (this.isSubscriptionWidget) {
          this.selectedOption.innerText = checked.getAttribute("radio-name");
        } else {
          this.selectedOption.innerText = checked.value;
        }
      }
    });
  }
}

customElements.define("gaia-select", GaiaSelect);

class GaiaMobileMenu extends GaiaDropdown {
  constructor() {
    super();
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      if (detailsElement.hasAttribute("open")) {
        detailsElement.setAttribute("aria-label", "Close Main Menu");
      } else {
        detailsElement.setAttribute("aria-label", "Open Main Menu");
      }
    }
  }

  open() {
    this.header =
      this.header ||
      document.querySelector(".shopify-section.section-header gaia-header");
    if (this.header)
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom)}px`
      );
    super.open();
    this.updateAriaLabel();
  }

  close() {
    console.log("closing");
    super.close();
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-mobile-menu", GaiaMobileMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {});
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class TotalPrice extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.updatePrice);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          mutation.target.updatePrice();
        }
      });
    });

    observer.observe(this, { attributes: true });

    this.updatePrice();
  }

  updatePrice() {
    if (
      !this.dataset.subscriptionDiscount ||
      this.dataset.subscriptionDiscount == "undefined"
    )
      this.dataset.subscriptionDiscount = 0;
    this.innerText = `£${(
      Math.round(
        (this.dataset.basePrice *
          (100 - this.dataset.subscriptionDiscount) *
          this.dataset.quantity) /
          100
      ) / 100
    ).toFixed(2)}`;
  }
}

customElements.define("total-price", TotalPrice);

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onSubscriptionChange);
    this.onSubscriptionChange();
  }

  onSubscriptionChange(sync = true) {
    let selected_type = this.querySelector(
      ".subscription-selector input:checked"
    );
    let subscription_options = this.querySelector(".subscription-options");
    let subscription_radios = subscription_options.querySelectorAll(
      'input[name="selling_plan"]'
    );
    let subscription_note = this.querySelector(".subscription-note");

    // Show/Hide subscription frequency options on what purchase type is selected
    if (selected_type.value == "onetime") {
      console.log("one time selected");
      subscription_options.classList.add("visually-hidden");
      // Uncheck all radios
      subscription_radios.forEach((radio) => {
        radio.checked = false;
      });
    } else if (selected_type.value == "subscription") {
      // Show subscription selector
      subscription_options.classList.remove("visually-hidden");
      // Check if any are checked, if not default check the first option
      let anySelected = Array.from(subscription_radios).some(
        (radio) => radio.checked
      );
      if (!anySelected && subscription_radios.length > 0) {
        subscription_radios[0].checked = true;
      }
    }

    // Update other widgets
    let widgets = document.querySelectorAll("subscription-widget");
    if (sync) {
      widgets.forEach((widget) => {
        if (widget != this) {
          // Update the purchase type radio button
          widget.querySelector(
            `.purchase-type input[value="${selected_type.value}"]`
          ).checked = true;
          // Update the selling plan radio buttons
          let widget_radios = widget.querySelectorAll(
            'input[name="selling_plan"]'
          );
          let selected_radio = Array.from(subscription_radios).find(
            (radio) => radio.checked
          );
          if (selected_radio) {
            widget.querySelector(
              `input[name="selling_plan"][value="${selected_radio.value}"]`
            ).checked = true;
          } else {
            // If no radio is selected, select the first one
            if (widget_radios.length > 0) {
              widget_radios[0].checked = true;
            }
          }
          widget.onSubscriptionChange(false);
        }
      });
    }
  }
}

customElements.define("subscription-widget", SubscriptionWidget);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.syncInputs();
    this.updateInventory();

    // Log raw variant data for debugging
    if (this.currentVariant) {
      console.log(
        "[Shopify Variant Change] Raw variant data:",
        this.currentVariant
      );
    } else {
      // console.log("[Shopify Variant Change] No current variant found.");
    }

    // Update inventory progress bar

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateBundleOptions();
      this.updateMedia();
      this.updateContent();
      this.updatePricing();
      this.updateSku();
      this.updatePackSize();
      this.updateSubscriptionPricing();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.setAvailableOptions();
    }
  }

  syncInputs() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc, #product-form-installment-${this.dataset.section}`
    );
    const thisSelects = this.querySelectorAll("select");
    const thisFieldsets = this.querySelectorAll("fieldset");
    productForms?.forEach((productForm) => {
      const variantSelects = productForm?.querySelectorAll("variant-selects");
      variantSelects?.forEach((variantSelect) => {
        if (variantSelect && variantSelect !== this) {
          const targetSelects = variantSelect.querySelectorAll("select");
          targetSelects.forEach((targetSelect, i) => {
            const thisValue =
              thisSelects[i]?.value ??
              thisFieldsets[i]?.querySelector("input[type=radio]:checked")
                .value;
            // console.log(targetSelect);
            targetSelect.value = thisValue;
          });
        }
      });
      const variantRadios = productForm?.querySelectorAll(
        "variant-radios, variant-details"
      );
      variantRadios?.forEach((variantRadio) => {
        if (variantRadio && variantRadio !== this) {
          const targetFieldsets = variantRadio.querySelectorAll("fieldset");
          targetFieldsets.forEach((targetFieldset, i) => {
            const thisValue =
              thisSelects[i]?.value ??
              thisFieldsets[i]?.querySelector("input[type=radio]:checked")
                .value;
            // console.log(targetFieldset);
            targetFieldset.querySelector(
              `input[type="radio"][value="${thisValue}"]`
            ).checked = true;
          });
        }
      });
    });
  }

  setAvailableOptions() {
    // only used in VariantRadios
  }

  // On variant change, get the progress bar (PDP block) and update to the latest variant's quantity
  updateInventory() {
    const variant = this.currentVariant;
    if (!variant) return;
    const section = document.querySelector(
      `#shopify-section-${this.dataset.section}`
    );
    if (!section) return;
    const inventoryList = section.querySelector(".product__inventory");
    if (!inventoryList) return;
    const progressBar = inventoryList.querySelector("progress-bar");
    if (!progressBar) return;

    // JSON helper in main-product.liquid under the block code snippet, it holds each variant's inventory quantity.
    // Match the currentVariant to the helper data to get the quantity
    const inventoryJsonEl = section.querySelector(
      `#variant-inventory-json-${this.dataset.section}`
    );
    let inventoryData = {};
    if (inventoryJsonEl) {
      try {
        inventoryData = JSON.parse(inventoryJsonEl.textContent);
      } catch (e) {
        // console.log("[Update Inventory] Failed to parse inventory JSON", e);
      }
    }
    const quantity =
      inventoryData[variant.id] !== undefined ? inventoryData[variant.id] : 0;
    progressBar.setAttribute("data-quantity", quantity);

    // Update inventory-count
    const inventoryCountEl = inventoryList.querySelector(".inventory-count");
    if (inventoryCountEl) {
      inventoryCountEl.textContent = quantity;
    }

    // Calculate and set --progress-bar-width
    // Find the max quantity among all variants for this product
    const maxQuantity = Math.max(...Object.values(inventoryData));
    let widthPercent = 100;
    if (maxQuantity > 0) {
      widthPercent = Math.max(5, Math.round((quantity / maxQuantity) * 100));
    }
    progressBar.style.setProperty("--progress-bar-width", widthPercent + "%");
  }

  updateOptions() {
    // console.log('VariantSelects - updateOptions()');
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(speed = 300) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    if (!mediaGallery) return;

    const media = mediaGallery.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );
    const variantSlide = getVariantMediaSlide(media, this.currentVariant);
    mediaGallery.swiper?.slideTo(variantSlide, speed);

    function getVariantMediaSlide(media, variant) {
      let i;
      for (i = 0; i < media.length; i++) {
        for (let v of JSON.parse(media[i].dataset.variants)) {
          if (v == variant.id) {
            return i;
          }
        }
      }
    }

    return variantSlide;
  }

  updateContent() {
    if (!this.currentVariant) return;

    const section = document.querySelector(
      `#shopify-section-${this.dataset.section}`
    );
    if (!section) return;

    const targets = section.querySelectorAll(".variant-content");
    targets.forEach((content) => {
      if (content.dataset.variant == this.currentVariant.id) {
        content.classList.remove("hidden");
      } else {
        content.classList.add("hidden");
      }
    });
  }

  updateSku() {
    // Find the selected variant id
    const variantId = this.currentVariant && this.currentVariant.id;
    if (!variantId) return;
    // Find all SKU elements in the closest product details container
    const skuItems =
      this.closest(".product-details")?.querySelectorAll(".product-sku--item");
    if (!skuItems) return;
    skuItems.forEach((el) => {
      if (el.getAttribute("data-variant-id") == variantId) {
        el.style.display = "";
      } else {
        el.style.display = "none";
      }
    });
  }

  updatePackSize() {
    // Find the selected variant id
    const variantId = this.currentVariant && this.currentVariant.id;
    if (!variantId) return;
    // Find all Pack Size elements in the closest product details container
    const packSizeItems =
      this.closest(".product-details")?.querySelectorAll(".variant-pack-size");
    if (!packSizeItems) return;
    let found = false;
    packSizeItems.forEach((el) => {
      if (el.getAttribute("data-variant-id") == variantId) {
        el.style.display = "";
        found = true;
      } else {
        el.style.display = "none";
      }
    });
    // If no matching element was found, hide all
    if (!found) {
      packSizeItems.forEach((el) => {
        el.style.display = "none";
      });
    }
  }

  updatePricing() {
    if (!this.currentVariant) return;

    // console.log(`#shopify-section-${this.dataset.section} .pricing`);
    const pricings = document.querySelectorAll(
      `#shopify-section-${this.dataset.section} .pricing`
    );
    pricings.forEach((pricing) => {
      if (pricing.dataset.variantId == this.currentVariant.id) {
        pricing.classList.add("active");

        const total_prices = document.querySelectorAll("total-price");
        total_prices.forEach((total_price) => {
          total_price.dataset.basePrice =
            pricing.querySelector(".price-current").dataset.price;
        });
      } else {
        pricing.classList.remove("active");
      }
    });
  }

  updateSubscriptionPricing() {
    if (!this.currentVariant) return;

    const prices = document.querySelectorAll(`.subscribe-price`);
    prices.forEach((price) => {
      if (price.dataset.variant == this.currentVariant.id) {
        price.classList.remove("visually-hidden");
      } else {
        price.classList.add("visually-hidden");
      }
    });
  }

  updateBundleOptions() {
    if (!this.currentVariant) return;

    const bundles = document.querySelectorAll(".simple-bundles");
    bundles.forEach((bundle) => {
      if (bundle.dataset.variant == this.currentVariant.id) {
        bundle.classList.add("active");
      } else {
        bundle.classList.remove("active");
      }

      const hiddenInputs = bundle.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach((hiddenInput) => {
        if (bundle.dataset.variant == this.currentVariant.id) {
          hiddenInput.removeAttribute("disabled");
        } else {
          hiddenInput.setAttribute("disabled", true);
        }
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl != "true") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    // Use the first <form> in the section
    const form = section.querySelector("form");
    if (!form) return;
    // If the form has a handleErrorMessage method, call it; otherwise, hide any error message wrapper
    if (typeof form.handleErrorMessage === "function") {
      form.handleErrorMessage();
    } else {
      const errorWrapper = form.querySelector(
        ".product-form__error-message-wrapper"
      );
      if (errorWrapper) errorWrapper.setAttribute("hidden", "");
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc`
    );
    if (!productForms) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else if (!addButton.classList.contains("multi-bundle-disabled")) {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const buttons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc`
    );
    buttons.forEach((button) => {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setAvailableOptions() {
    // Reset unavailable classes
    this.querySelectorAll('input[type="radio"]').forEach((option) => {
      option.classList.remove("unavailable");
    });

    this.variantData.forEach((variant) => {
      if (!variant.available) {
        variant.options.forEach((option, index) => {
          const fieldset = this.querySelectorAll("fieldset")[index];
          const gaiaSelect = this.querySelectorAll("gaia-select")[index];

          // Handle fieldsets
          if (fieldset) {
            const input = fieldset.querySelector(`input[value="${option}"]`);
            if (input) input.classList.add("unavailable");
          }

          // Handle gaia-selects
          if (gaiaSelect) {
            const input = gaiaSelect.querySelector(`input[value="${option}"]`);
            if (input) input.classList.add("unavailable");
          }
        });
      }
    });
  }

  updateOptions(event) {
    // Collect all fieldsets, including those inside gaia-select
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    // Extract selected options from all fieldsets
    this.options = fieldsets
      .map((fieldset) => {
        const checkedInput = fieldset.querySelector(
          "input[type=radio]:checked"
        );
        return checkedInput ? checkedInput.value : null;
      })
      .filter((option) => option !== null); // Remove null values

    // Update only the .selected-option in the changed gaia-select
    if (event && event.target && event.target.type === "radio") {
      const gaiaSelect = event.target.closest("gaia-select");
      if (gaiaSelect) {
        const selectedOption = gaiaSelect.querySelector(".selected-option");
        if (selectedOption) {
          selectedOption.innerText = event.target.value;
        }
      }
    }
    // console.log("Selected Options:", this.options);
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantDetails extends VariantRadios {
  constructor() {
    super();
    // Listen for radio changes and update only the correct .selected-option
    this.addEventListener("change", (event) => {
      if (event.target && event.target.type === "radio") {
        this.updateOptions(event);
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        variant.id == this.querySelector("input.variant-detail:checked").value
    );
  }

  setAvailableOptions() {
    return null;
  }
}

customElements.define("variant-details", VariantDetails);

class VariantSingleSelect extends VariantSelects {
  constructor() {
    super();
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) => variant.id == this.querySelector("select").value
    );
  }
}

customElements.define("variant-single-select", VariantSingleSelect);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.loadRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  /**
   * Fetches and renders this block's recommendations.
   *
   * Split out of connectedCallback's intersection handler so it can be called again later — the
   * observer unobserves after firing once, so there was previously no way to refresh. The cart
   * cross-sells use this to pull a new set once the shopper has added everything on offer
   * (scripts/cart-notification.js).
   *
   * Returns the fetch promise so callers can act on the outcome, e.g. decide whether anything
   * came back at all.
   */
  loadRecommendations() {
    return fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          // Nothing came back. The contents are left alone as before, but any loading
          // placeholder has to go or it spins forever.
          this.removeLoadingPlaceholder();
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        this.removeLoadingPlaceholder();
        console.error(e);
      });
  }

  // Clears the spinner rendered by snippets/cart-recommendations.liquid. Only the cart
  // cross-sell block renders one, so this is a no-op for the PDP section
  // (sections/product-recommendations.liquid) and any other caller of this element.
  removeLoadingPlaceholder() {
    const placeholder = this.querySelector(".cart-recommendations__loading");
    if (placeholder) placeholder.remove();
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function getCookie(name) {
  var cookieArr = document.cookie.split(";");

  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
}

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    this.init();
    // theme.initWhenVisible({
    //   element: this,
    //   callback: this.init.bind(this),
    //   threshold: 0,
    // });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      if (quantity == 0) progerss_width = 100;
      else {
        var progerss_width = (quantity * 100) / 30;
        if (progerss_width > 100) progerss_width = 100;
      }
      this.style.setProperty("--progress-bar-width", `${progerss_width}%`);
    }, 1e3);
  }
}
customElements.define("progress-bar", ProgressBar);
